import React from "react";
import Image from "next/image";

export const ImageWithFallback: React.FC<{
  src: any;
  alt: string;
  fallbackSrc: string;
  className?: any;
  fallbackClassName?: string;
  onClick?: (e: any) => void;
}> = ({ src, alt, fallbackSrc, className, fallbackClassName, onClick }) => {
  const [imgSrc, setImgSrc] = React.useState(src);
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    setImgSrc(src);
    setHasError(false);
  }, [src]);

  return (
    <>
      <Image
        unoptimized
        src={imgSrc || fallbackSrc}
        alt={alt}
        onError={() => {
          if (!hasError) {
            setImgSrc(fallbackSrc);
            setHasError(true);
          }
        }}
        className={`${className} ${hasError && fallbackClassName ? fallbackClassName : ""}`}
        width={1}
        height={1}
        onClick={onClick}
      />
    </>
  );
};
